import { denormalize } from 'normalizr';

import * as schemas from 'schemas';

export const getRegion = state =>
  denormalize(state.region.id, schemas.region, state.entities);



// WEBPACK FOOTER //
// ./src/store/region/selectors.js